import { useMemo } from "react";
import { DataTable } from "@/components/ui/data-table";
import type { Proforma } from "@/lib/proforma.api";
import { createProformaColumns } from "../proformaTableColumns";

interface ProformasTableProps {
  proformas: Proforma[];
  onSelect: (proforma: Proforma) => void;
}

export function ProformasTable({ proformas, onSelect }: ProformasTableProps) {
  const columns = useMemo(() => createProformaColumns(onSelect), [onSelect]);

  return (
    <DataTable
      columns={columns}
      data={proformas}
      emptyMessage="Aucune proforma."
      onRowClick={onSelect}
      pageSize={10}
    />
  );
}
